import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

const MARGEN = 8;

/**
 * Panel flotante anclado a un elemento. Va en un portal para que el scroll y el
 * overflow de la tabla no lo recorten; se cierra con clic fuera o Escape.
 */
const Popover = ({
  ancla = null,
  onClose,
  ancho = 280,
  alinear = 'izquierda',
  children = null,
  etiqueta = '',
}) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useLayoutEffect(() => {
    if (!ancla) return;
    const r = ancla.getBoundingClientRect();
    const izquierda = alinear === 'derecha' ? r.right - ancho : r.left;
    setPos({
      top: r.bottom + 4,
      left: Math.max(MARGEN, Math.min(izquierda, window.innerWidth - ancho - MARGEN)),
    });
  }, [ancla, ancho, alinear]);

  useEffect(() => {
    const fuera = (e) => {
      if (ref.current && !ref.current.contains(e.target) && !ancla?.contains(e.target)) onClose();
    };
    const tecla = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('mousedown', fuera);
    document.addEventListener('keydown', tecla);
    return () => {
      document.removeEventListener('mousedown', fuera);
      document.removeEventListener('keydown', tecla);
    };
  }, [ancla, onClose]);

  if (!ancla) return null;
  return createPortal(
    <div
      ref={ref}
      className="tbl-popover"
      role="dialog"
      aria-label={etiqueta}
      style={{ top: pos.top, left: pos.left, width: ancho }}
    >
      {children}
    </div>,
    document.body,
  );
};

Popover.propTypes = {
  ancla: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  ancho: PropTypes.number,
  alinear: PropTypes.oneOf(['izquierda', 'derecha']),
  children: PropTypes.node,
  etiqueta: PropTypes.string,
};

export default Popover;
